import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Market from "./components/Market";
import Signup from "./components/Signup";
import Login from "./components/Login";
import Navigation from "./components/Navigation";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import About from "./components/About";
import { AuthContext } from "./components/context/auth-context";
import { CartContext } from "./components/context/cart-context";
import { useAuth } from "./components/hooks/auth-hook";
import { useCart } from "./components/hooks/cart-hook";
import ErrorPage from "./components/ErrorPage";
import Cart from "./components/Cart/Cart";
import PaymentMessage from "./components/Cart/PaymentMessage";

function App() {
  const { isLoggedIn, login, logout } = useAuth();
  const {
    cart,
    cost,

    addToCart,
    removeFromCart,
    clearCart,
    increment,
    decrement,
  } = useCart();
  let routes;

  routes = (
    <Switch>
      <Route path="/" exact>
        <Market />
      </Route>
      <Route path="/signup" exact>
        <Signup />
      </Route>
      <Route path="/login" exact>
        <Login />
      </Route>
      <Route path="/about" exact>
        <About />
      </Route>
      <Route path="/cart" exact>
        <Cart />
      </Route>
      <Route path="/purchasesuccess">
        <PaymentMessage
          success
          messageDescription="Payment done successfully. Check the console for more details."
          messageHeading="Sucess"
        />
      </Route>
      <Route path="/purchasefail">
        <PaymentMessage
          messageDescription="Purchase was not completed"
          messageHeading="Error"
        />
      </Route>
      <Route>
        <ErrorPage />
      </Route>
    </Switch>
  );
  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        login: login,
        logout: logout,
      }}
    >
      <CartContext.Provider
        value={{
          cart: cart,
          cost: cost,
          removeFromCart: removeFromCart,
          addToCart: addToCart,
          clearCart: clearCart,
          increment: increment,
          decrement: decrement,
        }}
      >
        <Router>
          <Navigation />
          {routes}
        </Router>
      </CartContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
